import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  settings: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_SETTINGS_BUSY: (state, payload) => {
    state.settings.isBusy = payload;
  },
  LOAD_SETTINGS_SUCCESS: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.data = payload.data;
    state.settings.error = null;
  },
  LOAD_SETTINGS_FAIL: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.data = null;
    state.settings.error = payload;
  }
};

const actions = {
  getSettings: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_SETTINGS_BUSY', true);

    const config = {
      headers: { 'Authorization': setAccessToken(rootState) }
    };

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/settings`, config)
      .then(response => {
        response.data.data.outputs = response.data.data.outputs.map(output => {
          output.type = "output";
          output.output_id = output.id;
          delete output.id;
          return output;
        });
        commit('LOAD_SETTINGS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_SETTINGS_FAIL', error)
      });
  },

  getCategories: (_, { projectId }) => {
    return Axios.get(`/projects/${projectId}/queries/settings/categories`).then(r => r.data.data);
  },

  getBreakdowns: (_, { projectId }) => {
    return Axios.get(`/projects/${projectId}/queries/settings/breakdowns`).then(r => r.data.data);
  },

  getTags: (_, { projectId, categoryId, query, include }) => {
    let url = `/projects/${projectId}/queries/settings/tags?category_id=${categoryId}`;
    if (query) {
      url += `&query=${encodeURIComponent(query)}`;
    }
    if (include) {
      url += `&include=${encodeURIComponent(include)}`;
    }
    return Axios.get(url).then(r => r.data.data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};